import gsap from "gsap";
import EventDispatcher from "../../common/EventDispatcher";
import { Global } from "../../common/global";
import { resendOTP, verifyOTP } from "../../common/api";

export default class CodeVerify {
  constructor() {
    document
      .querySelector("#code_sec #codeVerifyBtn")
      .addEventListener("click", this.verifyCode.bind(this));
    document
      .querySelector("#code_sec #resend_trigger")
      .addEventListener("click", this.sendCode.bind(this, true));
    document
      .querySelector("#code_sec #otp_back")
      .addEventListener("click", this.goBack.bind(this));
  }
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));

    this.timeLeftToResend = 30;
    this.timeLeft = 0;
    this.canSendCode = false;
    this.verificationInProgress = false;
  }
  onEvents(data) {
    switch (data["message"]["event_type"]) {
      case "show_screen":
        this.showScreen(data["message"]["data"]);
        break;
    }
  }
  showScreen(data) {
    if (data["screenKey"] !== "CodeVerify") return false;

    document.querySelector("#code_sec").classList.add("active");
    document.querySelector("#code_sec #code").value = "";
    this.canSendCode = true;
    this.sendCode(false);
    // this.verifyCode();
  }

  async sendCode(sendCode) {
    if (!this.canSendCode) return false;

    if (sendCode) {
      document.querySelector("#loader").classList.add("active");
      const result = await resendOTP();
      document.querySelector("#loader").classList.remove("active");
    }
    this.timeLeft = 0;
    document.querySelector(".resend_cnt").innerHTML = this.timeLeftToResend;
    document.querySelector("#resend_trigger").classList.remove("active");
    this.canSendCode = false;
    this.counterTwn && this.counterTwn.kill();
    this.counterTwn = gsap.to(".resend_cnt", {
      innerHTML: 0, // Animates from 10 to 0
      duration: this.timeLeftToResend, // 10 seconds
      ease: "none",
      delay: 1,
      snap: {
        innerHTML: 1,
      }, // Snap to whole numbers
      onUpdate: function () {
        if (
          this.timeLeft ==
          Math.round(document.querySelector(".resend_cnt").innerHTML)
        )
          return false;

        this.timeLeft = Math.round(
          document.querySelector(".resend_cnt").innerHTML
        );
        document.querySelector(".resend_cnt").innerText = this.timeLeft;
      }.bind(this),
      onComplete: function () {
        this.canSendCode = true;
        document.querySelector("#resend_trigger").classList.add("active");
      }.bind(this),
    });
  }
  async verifyCode() {
    if (this.verificationInProgress) return false;

    Global.code = document.querySelector("#code_sec #code").value.trim();
    if (Global.code.length == 0) {
      document
        .querySelector("#code_sec #code")
        .parentElement.classList.add("error");
      return false;
    } else {
      document
        .querySelector("#code_sec #code")
        .parentElement.classList.remove("error");
    }

    this.verificationInProgress = true;
    document.querySelector("#loader").classList.add("active");
    // const result = await verifyOTP(Global.code);
    document.querySelector("#loader").classList.remove("active");
    console.log(result);
    if (result.statusCode != 200) {
      document.querySelector(".errorSec").innerHTML = result.message;
      document.querySelector(".errorSec").classList.add("active");
      this.errorTO && clearTimeout(this.errorTO);
      this.errorTO = setTimeout(() => {
        document.querySelector(".errorSec").classList.remove("active");
      }, 2000);

      document
        .querySelector("#code_sec #code")
        .parentElement.classList.add("error");
      this.verificationInProgress = false;
      return false;
    } else {
      localStorage.setItem("accessToken", result.accessToken);
      document.querySelector("#p-c").innerHTML = result.gameCount;
    }
    this.showNextScreen();
  }
  goBack() {
    this.counterTwn && this.counterTwn.kill();
    this.showRegister();
  }
  showRegister() {
    this.hideScreen();
    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "show_screen",
        data: {
          screenKey: "Register",
        },
      },
    });
  }
  showNextScreen() {
    this.hideScreen();
    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "show_screen",
        data: {
          screenKey: "Start",
        },
      },
    });
  }
  hideScreen() {
    document.querySelector("#code_sec").classList.remove("active");
  }
}
